import { VariableActionReference } from 'ai-constants'
import { IConditionActions } from 'bff'

export const evaluateTemplateAssetDisplay = (
  actions: IConditionActions[],
  asset: {
    type: VariableActionReference
    identifier: string
  },
) =>
  !actions
    .filter((event) => event.detail.type === asset.type)
    .some((observation) => {
      switch (observation.event) {
        case 'hide':
          return observation.detail.value.includes(asset.identifier || '')

        default:
          return false
      }
    })
